import { useQueryClient } from 'react-query';

import { useDelete } from '../utils/reactQuery';
import { ApiRoutesEnum } from '../utils/routes';

export const useDeleteCandidateFilter = () => {
  const queryClient = useQueryClient();
  return useDelete({
    url: ApiRoutesEnum.candidatesDeleteFilter,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.candidatesFilters]);
    },
  });
};
